import { render, staticRenderFns } from "./QueuetonResourceStatus.vue?vue&type=template&id=347c2bd8&"
import script from "./QueuetonResourceStatus.vue?vue&type=script&lang=js&"
export * from "./QueuetonResourceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347c2bd8')) {
      api.createRecord('347c2bd8', component.options)
    } else {
      api.reload('347c2bd8', component.options)
    }
    module.hot.accept("./QueuetonResourceStatus.vue?vue&type=template&id=347c2bd8&", function () {
      api.rerender('347c2bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/queueton/QueuetonResourceStatus.vue"
export default component.exports